// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Favorite48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Favorite48Filled: FC<Favorite48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m42 17.802 1.5.017v.017l-.001.028-.003.078a8.653 8.653 0 0 1-.144 1.072c-.135.69-.397 1.642-.896 2.776-1.002 2.275-2.945 5.24-6.687 8.275-3.688 2.99-6.328 5.773-8.038 7.796a39.553 39.553 0 0 0-1.882 2.394 22.42 22.42 0 0 0-.572.831l-.004.007-1.247 2.005-1.285-1.982-.005-.008-.026-.04a27.534 27.534 0 0 0-.604-.853 45.448 45.448 0 0 0-1.978-2.49 58.378 58.378 0 0 0-7.89-7.655c-3.763-3.02-5.709-5.988-6.708-8.272a13.241 13.241 0 0 1-.888-2.787 8.595 8.595 0 0 1-.138-1.078 3.62 3.62 0 0 1-.003-.078l-.001-.027v-.018s0-.002 1.5-.008l-1.5.006v-.006c0-3.294.918-5.726 2.291-7.483 1.359-1.74 3.077-2.709 4.513-3.247a10.523 10.523 0 0 1 7.164-.085l.271.1c2.662 1.035 4.298 3.347 5.261 5.272.995-1.989 2.711-4.391 5.531-5.371a10.524 10.524 0 0 1 7.165.084c1.435.54 3.154 1.509 4.513 3.248 1.373 1.757 2.291 4.188 2.291 7.482v.015l-1.5-.015Z" />
        </svg>
    );
};

export default Favorite48Filled;
